// extracted by mini-css-extract-plugin
module.exports = {"icon":"CartIcon-module--icon--3AlYQ","numberofitems":"CartIcon-module--numberofitems--VXbKj","cartlink":"CartIcon-module--cartlink--2o-2k"};